
import { Options, Vue } from "vue-class-component";
import { readLoginError } from "@/store/main/getters";
import { dispatchLogIn } from "@/store/main/actions";
import { envTag } from "@/env"; // @ is an alias to /src

@Options({
  components: {},
})
export default class Login extends Vue {
  public labelPosition = "right";
  public formLabelAlign = {
    username: "",
    password: "",
  };
  public async created() {
    // 如果是发布环境，就是从tapd跳转回来的，直接获取auth_token进行登陆
    const tapd_token =
      this.$route.query.auth_token !== null
        ? this.$route.query.auth_token
        : "";
    if (tapd_token) {
      await dispatchLogIn(this.$store, {
        username: "",
        password: "",
        tapd_token: tapd_token,
        login_type: "web",
      });
      this.$router.push({name: 'TestAppointment'})
    }
  }

  public get loginError() {
    return readLoginError(this.$store);
  }

  public submitForm(formName: string) {
    dispatchLogIn(this.$store, {
      username: this.formLabelAlign.username,
      password: this.formLabelAlign.password,
      tapd_token: "",
      login_type: "web",
    });
  }
}
